import React from 'react';
import './../../../Styles/Main/RentalPage/RentalRequestedForm.scss';
import { useState, useContext } from 'react';
import MyButton from '../../../UI/button/MyButton';
import MyInput from '../../../UI/input/MyInput';
import BlockSubstrate from '../../../UI/blocksubstrate/BlockSubstrate';
import { BrowserRouter as Router, Routes, Route, Link, RouterProvider} from 'react-router-dom';
import { SelectedBike } from '../../../Constant/context';

function RentalRequestedForm({ checkForm, ...props }) {

   const [paymentType, setPaymentType] = useState(false);
   const [nameValue, setNameValue] = useState('');
   const [numberValue, setNumberValue] = useState('');
   const [deliverAdressValue, setDeliverAdressValue] = useState('');
   const [returnAdressValue, setReturnAdressValue] = useState('');
   const [placeholderName, setplaceholderName] = useState('*Name')
   const [placeholderNumber, setplaceholderNumber] = useState('*Number')
   const [placeholderDeliveryAdress, setplaceholderDeliveryAdress] = useState('*Delivery adress');
   const [placeholderReturnAdress, setplaceholderReturnAdress] = useState('*Return adress');
   const [colorName, setColorName] = useState('#DDE3EB')
   const [colorNumber, setColorNumber] = useState('#DDE3EB')
   const [colorDelivery, setColorDelivery] = useState('#DDE3EB')
   const [colorReturn, setColorReturn] = useState('#DDE3EB')
   
   const {selectedDateGlobal, setSelectedDateGlobal } = useContext(SelectedBike)
   
   const changeTypePayment = () => {
      let globalDate = { ...selectedDateGlobal }
      if (paymentType) {
         setPaymentType(false)
         globalDate.payment = 'Online';
         setSelectedDateGlobal(globalDate);
      } else {
         setPaymentType(true);
         globalDate.payment = 'On spot';
         setSelectedDateGlobal(globalDate);
      }
   }

   const submitApplication = (e) => {
      e.preventDefault();
      
      if ((/^[0-9]+$/i.test(numberValue)) && (/^[a-zA-Z]+$/i.test(nameValue)) && deliverAdressValue !== '' && returnAdressValue !== '') {
         setNameValue('');
         setNumberValue('');
         setDeliverAdressValue('');
         setReturnAdressValue('');
         setColorNumber('#DDE3EB')
         setColorName('#DDE3EB')
         setplaceholderName('*Name');
         setplaceholderNumber('*Number')
         setplaceholderDeliveryAdress('*Delivery adress')
         setplaceholderReturnAdress('*Return adress')
         checkForm(true)
      } else {
         if (deliverAdressValue === '') {
            setColorDelivery('#ff0000')
            setDeliverAdressValue('');
            setplaceholderDeliveryAdress('Adress can`t be empty')
         }
         if (returnAdressValue === '') {
            setColorReturn('#ff0000')
            setReturnAdressValue('');
            setplaceholderReturnAdress('Adress can`t be empty')
         }
         if (!(/^[0-9]+$/i.test(numberValue))) {
            setColorNumber('#ff0000')
            setNumberValue('');
            setplaceholderNumber('Number: only 0-9')
         }
         if (!(/^[a-zA-Z]+$/i.test(nameValue))) {
            setColorName('#ff0000')
            setplaceholderName('Name: only A-Z a-z');
            setNameValue('')
         }
         setTimeout(() => {
            setColorName('#DDE3EB');
            setColorNumber('#DDE3EB');
            setColorDelivery('#DDE3EB');
            setColorReturn('#DDE3EB');
         }, 2000)
         checkForm(false)
      }
   }

   return (
      <div className='requestForm__wrapper'>
         <div className="requestForm__body">
            <div className="requestForm__column">
               <div className="requestForm__contact-info">
                  <div className="requestForm__signature-name requestForm__signature signature">Contact information</div>
                  <div className="requestForm__name">
                     <BlockSubstrate style={{border: `1px solid ${colorName}`}}>
                        <MyInput
                           type="text"
                           placeholder={placeholderName}
                           value={nameValue}
                           onChange={event => setNameValue(event.target.value)}
                        />
                     </BlockSubstrate>
                  </div>
                  <div className="requestForm__phone">
                     <BlockSubstrate style={{border: `1px solid ${colorNumber}`}}>
                        <MyInput
                           type="tell"
                           placeholder={placeholderNumber}
                           value={numberValue}
                           onChange={event => setNumberValue(event.target.value)}
                        />
                     </BlockSubstrate>
                  </div>
                  <div className="requestForm__signature-adress requestForm__signature signature">Delivery information</div>
                  <div className="requestForm__adress">
                     <BlockSubstrate style={{border: `1px solid ${colorDelivery}`}}>
                        <MyInput
                           type="text"
                           placeholder={placeholderDeliveryAdress}
                           value={deliverAdressValue}
                           onChange={event => setDeliverAdressValue(event.target.value)}
                        />
                     </BlockSubstrate>
                  </div>
                  <div className="requestForm__signature-payment requestForm__signature signature">Payment type</div>
                  <div className="requestForm__payment-online">
                     <BlockSubstrate>
                        <div
                           className="requestForm__insideWrapper text"
                           onClick={changeTypePayment}
                        >
                           <div className="requestRadioBut__radio-body">
                              <div className={ paymentType? "requestRadioBut__button" : "requestRadioBut__button requestRadioBut__button-active"}></div>
                              <div className="requestRadioBut__title">Online</div>
                           </div>
                        </div>
                     </BlockSubstrate>
                  </div>
                  <div className="requestForm__payment-onplace">
                     <BlockSubstrate>
                        <div
                           className="requestForm__insideWrapper text"
                           onClick={changeTypePayment}
                        >
                           <div className="requestRadioBut__radio-body">
                              <div className={ paymentType ? "requestRadioBut__button requestRadioBut__button-active" : "requestRadioBut__button"}></div>
                              <div className="requestRadioBut__title">On spot</div>
                           </div>
                        </div>
                     </BlockSubstrate>
                  </div>
               </div>
            </div>
            <div className="requestForm__column">
               <div className="requestForm__return-info">
                  <div className="requestForm__signature-date requestForm__signature signature">Return Date and Adress</div>
                  <div className="requestForm__return-date">
                     <BlockSubstrate>
                        <div className="requestForm__insideWrapper text">
                           {selectedDateGlobal['finishDate']}
                        </div>
                     </BlockSubstrate>
                  </div>
                  <div className="requestForm__return-time">
                     <BlockSubstrate>
                        <div className="requestForm__insideWrapper text">
                           12:00
                        </div>
                     </BlockSubstrate>
                  </div>
                  <div className="requestForm__return-adress">
                     <BlockSubstrate style={{border: `1px solid ${colorReturn}`}}>
                        <MyInput
                           type="text"
                           placeholder={placeholderReturnAdress}
                           value={returnAdressValue}
                           onChange={event => setReturnAdressValue(event.target.value)}
                        />
                     </BlockSubstrate>
                  </div>
                  <div className="requestForm__return-rules">
                     <div className="requestForm__rules-title requestForm__signature signature">Return bike</div>
                     <div className="requestForm__rules-text text">
                        You must return the Rental Bike on the agreed upon date/time at the agreed upon location. Remember to return the bike and all the rental equipment in the condition you received it to avoid additional charges. Additional fees may apply for excessive cleaning and/or repairs beyond normal wear and tear.
                     </div>
                     <div className="requestForm__rules-title requestForm__signature signature">Return adress</div>
                     <div className="requestForm__rules-text text">
                        You can also enter the address of another location where we will pick up your bike.
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="requestForm__button">
            <Link to='/rental'>
               <MyButton
                  style={{ fontSize: '20px', fontWeight: '700' }}
                  onClick={submitApplication}
               >
                  Book
               </MyButton>
            </Link>
         </div>
      </div>
   );
}
export default RentalRequestedForm;